import actionTypes from '../constants/action-types';

const setDependencies = (dependencies) => ({
  type: actionTypes.SET_DEPENDENCIES,
  payload: {
    dependencies,
  },
});

export default setDependencies;
